export default "__VITE_ASSET__D2121RNl__"